"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BulletList;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _density = require("@site/pattern-library-utils/density");
const BulletListContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "BulletListContainer",
  class: "pc-b1x93pna"
});

/**
 * BulletList Component
 *
 * @param {Object} props React props
 * @param {Array} props.list Array of list items with content property
 * @param {string} props.dataCy data-cy attribute for testing
 * @returns {React.ReactElement} BulletList component
 * @public
 */
function BulletList({
  list = [],
  dataCy = 'product'
}) {
  if (!list || list.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(BulletListContainer, {
    "data-cy": `${dataCy}-bullet-list`
  }, list.map(({
    content
  }, index) => /*#__PURE__*/_react.default.createElement(_text.default.li, {
    key: `bullet-${index}`,
    as: "caption",
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(content)
    }
  })));
}
BulletList.propTypes = {
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string.isRequired
  })),
  dataCy: _propTypes.default.string
};